import * as React from 'react';

const ArrowsSync16: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'>
			<path
				d='M12.7375 5.82812C12.9328 5.63295 13.2493 5.63301 13.4446 5.82812L15.3538 7.7373C15.5487 7.93258 15.5489 8.24918 15.3538 8.44434C15.1586 8.63942 14.842 8.63924 14.6467 8.44434L13.5393 7.33691C13.5726 7.58357 13.5911 7.83542 13.5911 8.09082C13.5908 11.1783 11.0878 13.6815 8.00024 13.6816C6.5829 13.6816 5.28722 13.1536 4.302 12.2842C4.095 12.1015 4.07541 11.7852 4.25806 11.5781C4.4408 11.3712 4.75711 11.3515 4.96411 11.5342C5.77364 12.2485 6.83586 12.6816 8.00024 12.6816C10.5355 12.6815 12.5908 10.626 12.5911 8.09082C12.5911 7.86849 12.5727 7.65003 12.5422 7.43652L11.5354 8.44434C11.3402 8.63938 11.0236 8.63923 10.8284 8.44434C10.6333 8.2491 10.6333 7.93253 10.8284 7.7373L12.7375 5.82812ZM8.00024 2.5C9.41761 2.50007 10.7133 3.028 11.6985 3.89746C11.9052 4.08024 11.9251 4.3966 11.7424 4.60352C11.5598 4.81035 11.2434 4.82983 11.0364 4.64746C10.2269 3.9331 9.16464 3.50007 8.00024 3.5C5.46478 3.5 3.40947 5.55537 3.40942 8.09082C3.40944 8.31272 3.42693 8.53097 3.45728 8.74414L4.46509 7.7373C4.66036 7.54218 4.9769 7.54209 5.17212 7.7373C5.36696 7.93255 5.36712 8.24919 5.17212 8.44434L3.26294 10.3535C3.0678 10.5486 2.75118 10.5484 2.55591 10.3535L0.646729 8.44434C0.451531 8.24909 0.451543 7.93256 0.646729 7.7373C0.841979 7.5421 1.15851 7.5421 1.35376 7.7373L2.46021 8.84375C2.42703 8.59748 2.40944 8.34586 2.40942 8.09082C2.40947 5.00309 4.9125 2.5 8.00024 2.5Z'
				fill='#666666'
			/>
		</svg>
	);
};

export default ArrowsSync16;

